/*
  RBN: Quick Add image carousel helpers (snippets/quick-add-modal loads this file).
  The carousel itself is the theme's slideshow (arrows, swipe, infinite loop); the layout is in
  snippets/quick-add-modal-styles. This adds an image counter ("2 / 4") and left / right arrow keys while the
  gallery has focus. Nothing here touches the variant, price or cart. If this file fails to load, the carousel
  and its arrows still work, only without the counter.
*/
(function () {
  if (window.rbnQuickAddGallery) return;
  window.rbnQuickAddGallery = true;

  function content() {
    return document.getElementById('quick-add-modal-content');
  }

  function update(show, selected) {
    var slides = show.querySelectorAll('slideshow-slides > slideshow-slide');
    var container = show.querySelector('slideshow-container');
    var scroller = show.querySelector('slideshow-slides');
    if (!container || !scroller) return;
    var counter = container.querySelector('.rbn-qa-counter');
    if (slides.length < 2) {
      if (counter) counter.remove();
      return;
    }
    if (!counter) {
      counter = document.createElement('span');
      counter.className = 'rbn-qa-counter';
      counter.setAttribute('aria-live', 'polite');
      container.appendChild(counter);
    }
    /* The last index this slideshow reported; a new gallery (other color) starts on its first image. */
    if (typeof selected === 'number') show.rbnIndex = selected;
    var index = typeof show.rbnIndex === 'number' ? show.rbnIndex : 0;
    index = Math.min(Math.max(index, 0), slides.length - 1);
    var text = index + 1 + ' / ' + slides.length;
    if (counter.textContent !== text) counter.textContent = text;
    if (scroller.getAttribute('tabindex') !== '0') scroller.setAttribute('tabindex', '0');
    if (!scroller.hasAttribute('aria-label')) scroller.setAttribute('aria-label', 'Product images');
  }

  function updateAll() {
    var root = content();
    if (!root) return;
    root.querySelectorAll('.product-information__media media-gallery > slideshow-component').forEach(function (show) { update(show); });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; updateAll(); });
  }

  function init() {
    var root = content();
    if (!root) return;
    /* Quick Add fills the modal (open, other product) and swaps the gallery when the color changes. */
    new MutationObserver(queue).observe(root, { childList: true, subtree: true });
    /* The slideshow announces every slide change (arrows, swipe, keyboard). */
    root.addEventListener('slideshow:select', function (e) {
      var show = e.target && e.target.matches && e.target.matches('.product-information__media media-gallery > slideshow-component') ? e.target : null;
      if (show && e.detail && typeof e.detail.index === 'number') update(show, e.detail.index);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var show = e.target && e.target.closest && e.target.closest('.product-information__media media-gallery > slideshow-component');
      if (!show || typeof show.next !== 'function') return;
      e.preventDefault();
      if (e.key === 'ArrowLeft') show.previous(); else show.next();
    });
    updateAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
